import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AccountSelection from '../components/AccountSelection';

const SelectAccountForHistoryPage = () => {
  const navigate = useNavigate();
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  
  // Dummy state setters required by AccountSelection, but not used for display in this page
  const [accountBalance, setAccountBalance] = useState(null);
  const [accountEquity, setAccountEquity] = useState(null);
  // const [riskPercent, setRiskPercent] = useState(null); // Also potentially needed if AccountSelection uses setRiskPercentFromSettings

  useEffect(() => {
    if (selectedAccountId) {
      navigate(`/accounts/${selectedAccountId}/trade-history`);
    }
  }, [selectedAccountId, navigate]);

  return (
    <div className="p-3 sm:p-4 md:p-6 bg-backgroundBody text-textPrimary min-h-screen">
      <h1 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-primary">
        Select Account for Trade History
      </h1>
      <p className="mb-3 sm:mb-4 text-sm sm:text-base text-textSecondary">
        Please select an account to view its trade history.
      </p>
      <AccountSelection
        selectedAccount={selectedAccountId}
        setSelectedAccount={setSelectedAccountId}
        accountBalance={accountBalance} // Pass even if not displayed here
        setAccountBalance={setAccountBalance} // Pass even if not displayed here
        accountEquity={accountEquity} // Pass even if not displayed here
        setAccountEquity={setAccountEquity} // Pass even if not displayed here
        // setRiskPercentFromSettings={setRiskPercent} // Uncomment if AccountSelection strictly needs it
      />
    </div>
  );
};

export default SelectAccountForHistoryPage;
